import '../vendor/oo_engine'
import initOpinionLab from './initOpinionLab'

export default {
  name: 'FeedbackLink',
  props: {
    clientId: {
      type: String,
      default: null
    },
    flow: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Feedback'
    },
    srcCorrelationId: {
      type: String,
      default: null
    }
  },
  methods: {
    launchOpinionLab (event) {
      initOpinionLab({
        clientId: this.clientId,
        flow: this.flow,
        srcCorrelationId: this.srcCorrelationId
      })
      window.OOo.inlineFeedbackShow(event)
    }
  },
  template: '<a href="#" @click="launchOpinionLab">{{ label }}</a>'
}
